import { autoserializeAs, autoserializeAsArray } from 'dcerialize';

import { AnnouncementTypeEnum } from '../definitions/announcement-type.enum';


/**
 * Announcement body
 */
export class AnnouncementBody {
  /**
   * Spanish body
   */
  @autoserializeAs(() => String) es: string;

  /**
   * English body
   */
  @autoserializeAs(() => String) en: string;

  /**
   * Italian body
   */
  @autoserializeAs(() => String) it: string;


  /**
   * @param es
   * @param en
   * @param it
   */
  constructor(es: string, en: string, it: string) {
    this.es = es;
    this.en = en;
    this.it = it;
  }

  /**
   * Gets an array with the property names
   */
  static getPropertyNames(): string[] {
    return ['es', 'en', 'it'];
  }
}


/**
 * Announcement CRUD class
 */
export class Announcement {
  /**
   * ID
   */
  @autoserializeAs(() => Number) _id!: number;

  /**
   * Customer list where the announcement is shown
   */
  @autoserializeAsArray(() => String) customers: string[];

  /**
   * Announcement type
   */
  @autoserializeAs(() => String) type: AnnouncementTypeEnum;

  /**
   * Announcement body
   */
  @autoserializeAs(() => AnnouncementBody) body: AnnouncementBody;

  /**
   * Announcement start date
   */
  @autoserializeAs(() => Date) startDate?: Date;

  /**
   * Announcement end date
   */
  @autoserializeAs(() => Date) endDate?: Date;

  /**
   * Whether the announcement is active
   */
  @autoserializeAs(() => Boolean) isActive?: boolean;

  constructor(
    customers: string[] = [],
    type: AnnouncementTypeEnum,
    body: AnnouncementBody,
    startDate?: Date,
    endDate?: Date,
    isActive?: boolean
  ) {
    this.customers = customers;
    this.type = type;
    this.body = body;
    this.startDate = startDate;
    this.endDate = endDate;
    this.isActive = isActive;
  }
}
